import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);
function stoofColumnMoreFrontend(isResize = false) {
    if(document.querySelector('.column-has-mobile-toggler--button')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        const allTogglerContainers = document.querySelectorAll('.column-has-mobile-toggler');
        allTogglerContainers.forEach(togCont => {

            let tl = gsap.timeline({ });
            function myListener(ev){

                doThisWhenClicked(ev, tl);
            }
            togCont.addEventListener('click',  myListener );
            if (vw > 780) {


                togCont.removeEventListener('click', myListener);
                tl.kill();

            }
        })




        const doThisWhenClicked = (ev, tl) => {

            //const matches = ev.target.matches ? ev.target.matches('.column-has-mobile-toggler--button') : ev.target.msMatchesSelector('.column-has-mobile-toggler--button');
            if (!ev.target.closest('.column-has-mobile-toggler')) return;
            if (ev.target.closest('.wp-block-button__link') || ev.target.closest('.stoof-business-card-wrapper')) return;
            const wrapper = ev.target.closest('.column-has-mobile-toggler');
            const button = wrapper.querySelector('.column-has-mobile-toggler--button');
            const section = button.closest('.wp-block-stoof-stoof-row-block');
            const hidden = button.closest('.column-has-mobile-toggler');
            const hiddenHeight = hidden.clientHeight;
            if(!button.classList.contains('column-has-mobile-toggler--button__open')){

                tl.fromTo(hidden, {maxHeight: '3.5rem'}, {duration: 2, maxHeight: hiddenHeight});
                tl.fromTo(button, {rotation: 0}, {rotation: 180, duration: 3}, '-2')

            }else{
                tl.fromTo(hidden, {maxHeight: '100%'}, {duration: 1, maxHeight: '3.75rem'} );
                tl.fromTo(button, {rotation: 180}, {rotation: 0, duration: 2}, '-1' )

                //tl.to(window, {duration: 0.5, scrollTo: section});
            }





            hidden.classList.toggle('column-has-mobile-toggler__show');
            button.classList.toggle('column-has-mobile-toggler--button__open');



        }
    }


}

export default stoofColumnMoreFrontend;